import { RESET_STORE } from 'store/constants';

export const forceStateUpdateOnQueryStarted = async (
  dispatch,
  action,
  data,
) => {
  dispatch(action(data));
};

export const defaultActionAsyncHandler = async (
  { dispatch, queryFulfilled, queryArgs },
  action,
) => {
  try {
    const res = await queryFulfilled;

    if (res) {
      const actionProps = queryArgs
        ? {
          data: res.data,
          queryArgs,
        }
        : res.data;

      dispatch(action(actionProps));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};

export const cmsApiActionHandler = async (
  { dispatch, queryFulfilled },
  action,
) => {
  try {
    const res = await queryFulfilled;
    if (res) {
      dispatch(action(res.data?.data || []));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};

export const resetDataMiddleware =
  ({ getState }) =>
    (next) => {
      const initialAppState = getState();

      return (action) => {
        if (action.type === RESET_STORE) {
          const actionWithInitialAppState = {
            ...action,
            payload: initialAppState,
          };

          return next(actionWithInitialAppState);
        }

        return next(action);
      };
    };

export const buildUrlWithExtraParams = (baseUrl, extraAttributes = []) => {
  const params = extraAttributes
    .map((attr) => `extra_fields=${encodeURIComponent(attr)}`)
    .join('&');

  return !extraAttributes || extraAttributes.length === 0
    ? baseUrl
    : `${baseUrl}?${params}`;
};

export const downloadResponseHandler = async (request, property) => {
  try {
    const { data } = await request;
    if (data) {
      return window.location.assign(data[property]);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Download Error:', error);
  }
};
